



































import { Loader } from 'mycorems-app-shared';
import HasTaskMixin from '../components/HasTaskMixin';
import recognition from '../auth/recognition';
import { AccountService, User } from '../types';
import userRepository from '../user/user-repository';
import accountServiceRepository from '../account/service/account-service-repository';
import UserRolesList from './UserRolesList.vue';

interface Data {
  user: User|null,
  accountServices: AccountService[],
  openServices: Object,
}

export default HasTaskMixin.extend({
  props: {
    userId: {
      type: String,
      required: true,
    },
    showAssignable: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      user: null,
      accountServices: [],
      openServices: {},
    };
  },
  computed: {
    permittedServices(): AccountService[] {
      return this.accountServices.filter(
        as => recognition.hasService(as.service.name),
      );
    },
  },
  watch: {
    userId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this
        .loadUser()
        .then(this.loadAccountServices);
    },
    loadUser(): Promise<User> {
      this.task = userRepository
        .find(this.userId)
        .then((user) => {
          this.user = user;
        });
      return this.task;
    },
    loadAccountServices(): void {
      if (!this.user) return;
      this.task = accountServiceRepository.findAll(this.user.accountId);
      this.task.then((accountServices: AccountService[]) => {
        this.accountServices = accountServices;
      });
    },
  },
  created(): void {
    this.load();
  },
  components: {
    Loader,
    UserRolesList,
  },
});
